import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const walletApiEndPoint = `${process.env.NEXT_PUBLIC_APP_API_URL}/api/wallet/admin`;

export const getAdminWalletLogsThunk = createAsyncThunk(
    "admin-wallet-logs",
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${walletApiEndPoint}/transactions`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to fetch wallet logs" }
            )
        }
    }
)
